import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ForeignKeyDataService} from './foreign-key-data.service';
import {
  RestFilterModel,
  RestPaginationModel,
  RestQueryParams,
  RestSimpleResponseParser,
  RestYiiFilterService,
  RestYiiPagination,
  RestYiiSort
} from 'gelios-ng-admin-components';
import {Observable, of, Subject, Subscription} from 'rxjs';
import {debounceTime, map, switchMap, tap} from 'rxjs/operators';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import {AuthorizationService} from '../../../app/authorization/authorization.service';

@Component({
  selector: 'app-gelios-foreign-key-field',
  templateUrl: './gelios-foreign-key-field.component.html'
})
export class GeliosForeignKeyFieldComponent extends GeliosFieldBaseComponent implements OnInit, OnDestroy {
  public keyField: string;
  public displayedField: string;
  protected foreignKeyDataService: ForeignKeyDataService;
  public items: Subject<Array<any>> = new Subject<Array<any>>();
  public groupBy: ((item: any) => string) | string = null;
  public loading = true;
  public filterBehaviorSubjectSubscription: Subscription;
  public itemsSubscription: Subscription;
  public cache = [];
  constructor(
    protected httpClient: HttpClient,
    translateService: TranslateService,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string,
    protected authorizationService: AuthorizationService
  ) {
    super(translateService);
    this.foreignKeyDataService = new ForeignKeyDataService(
      httpClient,
      new RestYiiFilterService(),
      new RestYiiSort(),
      new RestYiiPagination(),
      new RestSimpleResponseParser(),
      environmentVersion,
      environmentApiBasepoint,
      authorizationService
    );
  }

  ngOnInit() {
    super.ngOnInit();
    console.log(this.reflexiveField.foreignSource.fields);
    this.groupBy = this.reflexiveField.foreignSource.groupBy ? this.reflexiveField.foreignSource.groupBy : null;
    this.keyField = this.reflexiveField.foreignSource.keyField;
    this.displayedField = this.reflexiveField.foreignSource.displayedField;
    this.foreignKeyDataService
      .setModelName(this.reflexiveField.foreignSource.modelName)
      .setFields(this.reflexiveField.foreignSource.fields)
      .setExpand(this.reflexiveField.foreignSource.expand || '')
      .setSearchModelName(this.reflexiveField.foreignSource.searchModelName);

    // this.items = this.getItemsObservable();

    this.itemsSubscription =  this.getItemsObservable().subscribe(items => {
      const idField = this.reflexiveField.foreignSource.keyField || 'id';
      this.items.next(items);
      if (this.reflexiveField.foreignSource.items) {
        this.reflexiveField.foreignSource.items.next(items);
      }

      const currentValueIsNotEmpty = this.reflexiveField.foreignSource.multiple ?
        (this.formGroup.controls[this.fieldName].value && this.formGroup.controls[this.fieldName].value.length)
        : this.formGroup.controls[this.fieldName].value;
      if (
        this.reflexiveField.foreignSource.autoClearIfValueNotInList
        && this.formGroup
        && this.formGroup.controls[this.fieldName]
        && currentValueIsNotEmpty
      ) {
        if (this.reflexiveField.foreignSource.multiple) {
          const currentValue = this.formGroup.controls[this.fieldName].value as any[];
          const filtered = currentValue.filter(
            currentValueItem => items.findIndex(item => item[idField] === currentValueItem) > -1
          );
          if (filtered.length < currentValue.length) {
            this.formGroup.controls[this.fieldName].setValue(filtered);
          }
        } else {
          const currentValue = this.formGroup.controls[this.fieldName].value;
          const index = items.findIndex(item => item[idField] === currentValue);
          if (index === -1) {
            this.formGroup.controls[this.fieldName].setValue(undefined);
          }
        }
      }
      if (
        this.reflexiveField.foreignSource.autoSelectIfOnlyOneOption
        && this.formGroup
        && this.formGroup.controls[this.fieldName]
        && !currentValueIsNotEmpty
        && items.length === 1
      ) {
        this.formGroup.controls[this.fieldName].setValue(
          this.reflexiveField.foreignSource.multiple ? [items[0][idField]] : items[0][idField]
        );
      }
    });
  }
  protected getItemsObservable() {
    const restFilterObservable: Observable<RestFilterModel> = this.reflexiveField.foreignSource.filterBehaviorSubject ?
      this.reflexiveField.foreignSource.filterBehaviorSubject : of(this.reflexiveField.foreignSource.filter);
    return restFilterObservable.pipe(
      switchMap(
        restFilterModel => {
          const restQueryParams: RestQueryParams = new RestQueryParams();
          restQueryParams.filterModel = restFilterModel;
          restQueryParams.sortModel = this.reflexiveField.foreignSource.sort ? this.reflexiveField.foreignSource.sort : [];
          const pageSize = 20000;
          const page = 1;
          restQueryParams.paginationModel = {pageSize: pageSize, page: page} as RestPaginationModel;
          return this.foreignKeyDataService
            .getAll(restQueryParams)
            .pipe(
              tap(() => this.loading = false),
              tap((response) => this.cache = response.body),
              map(response => {
                if (this.reflexiveField.foreignSource.displayedFieldWithId) {
                  response.body.map((el) => {
                    el[this.displayedField] = 'ID ' + el.id + ' ' + el[this.displayedField];
                    return el;
                  });
                }
                if (this.reflexiveField.foreignSource.additionKey) {
                  response.body.map((el) => {
                    el[this.displayedField] = el[this.reflexiveField.foreignSource.additionKey]
                      ? el[this.displayedField] + ' (' + el[this.reflexiveField.foreignSource.additionKey] + ')'
                      : el[this.displayedField];
                    return el;
                  });
                }
                return response.body;
              })
            );
        }
      )
    );
  }

  public isMultiple() {
    return !!this.reflexiveField.foreignSource.multiple;
  }

  ngOnDestroy(): void {
    [this.filterBehaviorSubjectSubscription, this.itemsSubscription]
      .filter(s => !!s)
      .forEach(s => s.unsubscribe());
  }

  onValueChange(event) {
    if (Array.isArray(event)) {
      super.onValueChange({value: event, model: this.cache.filter(e => event.includes(e[this.keyField]))});
    } else {
      super.onValueChange({value: event, model: this.cache.find(i => i[this.keyField] === event)});
    }
  }
}
